<template>
  <div id="messages-filter">
    <!--DRO 26/05/2023 : Div commentée car affichage d'une barre blanche qui prend de la place pour rien
    <div v-if="isSmartphoneOS">
      <f7-navbar v-if="showListGroupPanel()">
        <b-row v-if="hasRight('rtp_group_create')">
          <b-col>
            <b-button variant="primary" size="sm"
              :class='mode === 1 ? "navbar-button-selected": "navbar-button"'
              @click="applyFilter(1)">
              {{ $t('filter.tab_unit') }}
            </b-button>
          </b-col>
          <b-col>
            <b-button variant="primary" size="sm"
              :class='mode === 2 ? "navbar-button-selected": "navbar-button"'
              @click="applyFilter(2)">
              {{ $t('filter.tab_group') }}
            </b-button>
          </b-col>
        </b-row>
      </f7-navbar>
    </div>-->
    <!-- DRO 26/05/2023: Aussi commenté pour pas qu'il y ait de la place prise pour rien
    <f7-list accordion v-else id="directPayments-filter">
      <!~~ TLV 15/01/2021 - showing filter title only if there is only one tab
          If there are multiple tabs in the filter (case of supplier service),
            the tabs are stored in the parent component ~~>
      <f7-list-item class="filterTitle"
         id="filter-item mb-5" v-if="aloneTab">
        <!~~ <i class="fa-light fa-filter showSmallScreenOnly mousePointer" size="17px"
          @click="$bus.emit('right-panel-open', serviceId)" slot="content">
        </i> ~~>
        <div class="mt-3" style="display:flex;width:300px;" v-if="showListDraftPanel()">
          <b-button class="btn" size="sm"
            :class='modeFilter === 1 ? "navbar-button-selected": "navbar-button"'
            @click="applyFilter(1)">
            {{ $t('filter.tab_sent') }}
          </b-button>
          <b-button class="btn" size="sm"
            :class='modeFilter === 0 ? "navbar-button-selected": "navbar-button"'
            @click="applyFilter(0)">
            {{ $t('filter.tab_draft') }}
          </b-button>
        </div>
      </f7-list-item>
    </f7-list>-->

    <f7-list>
      <!-- Boutons de sélection/sauvegarde/suppression/application du filtre -->
      <f7-list-item :class="additionalClass">
        <b-row class="justify-content-start no-gutter w-100">
          <!-- Left section filtre -->
          <!-- <b-col cols="1" class="showLargeScreenOnly">
            <b-button class="btn btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus" style="font-size: 14px"></i>
              <i v-else class="fa-light fa-plus" style="font-size: 14px"></i>
            </b-button>
          </b-col> -->
          <fieldset class="d-flex">
            <legend class="sr-only">{{ $t('filter.actions') }}</legend>
            <div class="form-group mr-2">
              <b-button class="btnFilter"
                @click="$emit('refreshInbox')"
                :aria-label="$t('common.rfrsh')"
                :title="$t('common.rfrsh')">
                <i class="fa fa-rotate-right fs-14px" aria-hidden="true"></i>
                <!-- <span class="fab-label">{{ $t('common.rfrsh') }}</span> -->
              </b-button>
            </div>
            <!-- Right section filtre -->
            <div class="form-group mx-2">
              <b-button class="btnFilter_2"
                @click="$emit('extractCSV')"
                :aria-label="$t('common.extract_list')"
                :title="$t('common.extract_list')">
                <i class="fa-light fa-upload fs-14px" aria-hidden="true"></i>
                <span class="fab-label">{{ $t('common.extract_list') }}</span>
              </b-button>
            </div>
          </fieldset>
          <fieldset class="form-group mx-2">
            <legend class="sr-only">{{ $t('filter.filter_by_direction') }}</legend>
            <b-button-group class="mt-sm-0" role="group" :aria-label="$t('filter.filter_by_direction')">
              <b-button 
                :variant="role === 2 ? 'primary' : ''" 
                @click="role = 2"
                :aria-pressed="role === 2 ? 'true' : 'false'"
                :aria-label="$t('common.all')">{{ $t('common.all') }}</b-button>
              <b-button 
                :variant="role === 1 ? 'primary' : ''" 
                @click="role = 1"
                :aria-pressed="role === 1 ? 'true' : 'false'"
                :aria-label="$t('common.sent')">{{ $t('common.sent') }}</b-button>
              <b-button 
                :variant="role === 0 ? 'primary' : ''" 
                @click="role = 0"
                :aria-pressed="role === 0 ? 'true' : 'false'"
                :aria-label="$t('common.received')">{{ $t('common.received') }}</b-button>
            </b-button-group>
          </fieldset>
          <b-col cols="1" class="p-0" offset="3" v-if="showListGroupPanel() && hasRight('rtp_group_create')">
            <b-button variant="primary" size="sm"
              :class='modeFilter === 1 ? "navbar-button-selected": "navbar-button"'
              @click="applyFilter(1)">
              {{ $t('filter.tab_unit') }}
            </b-button>
          </b-col>
          <b-col cols="1" class="p-0" v-if="showListGroupPanel() && hasRight('rtp_group_create')">
            <b-button variant="primary" size="sm"
              :class='modeFilter === 2 ? "navbar-button-selected": "navbar-button"'
              @click="applyFilter(2)">
              {{ $t('filter.tab_group') }}
            </b-button>
          </b-col>
          <b-col cols="12" sm="5" md="4" xl="4" v-if="showButtonCreateVerify()" offset="0">
            <b-button variant="primary" class="btnFilter_2 mt-3 mt-xl-0"
              @click="$emit('createVerify')">
              <i class="fa-light fa-plus fs-14px"></i>
              <span class="fab-label">{{ $t('verifications.verify') }}</span>
            </b-button>
          </b-col>
          <b-col cols="2" class="showLargeScreenOnly" v-if="showButtonImportLot()">
            <b-button class="btnFilter"
              @click="$emit('refreshInbox')">
              <i f7="fa-light fa-upload fs-14px"></i>
              <span class="fab-label">{{ $t('common.imprt_list') }}</span>
            </b-button>
          </b-col>

          <!-- TLV 15/01/2021 - Button for showing the filter on small screens more clearly -->
          <!-- DRO 30/05/2023 : Filtre commenté pour l'instant sous l'ordre de Victor-->
          <!--
          <b-col cols="6" md="8" class="showSmallScreenOnly">
            <b-button class="btnFilter_2 mt-3"
              @click="$bus.emit('right-panel-open', serviceId)">
              {{ $t('filter.slct_fltr') }}
            </b-button>
          </b-col>
          -->

          <b-col cols="5" offset="7" class="d-flex flex-row-reverse showLargeScreenOnly mt-25px" v-if="displayFilter">
            <!-- Attention : les boutons s'affichent de droite à gauche -->
            <!-- <b-button class="btn btnFilter"
              :disabled="!hasDefaultFilter"
              @click="deleteFilter"
              style="margin-right: 0.5cm;">
              {{ $t('filter.cln_fltr') }}
            </b-button>
            <b-button class="btn" size="sm"
              :disabled="!hasInputFilter"
              @click="saveDefaultFilter"
              style="margin-right: 0.5cm;">
              {{ $t('filter.sv_fltr') }}
            </b-button> -->
          </b-col>
        </b-row>
      </f7-list-item>
      <!-- Sélection des valeurs de Filtre -->
      <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}"
        class="showLargeScreenOnly">
        <b-row class="min-w-100">
          <b-col cols="9" class="d-flex row justify-content-start">
            <!-- Filtre d'id du fournisseur (qui s'affiche si la raison sociale est affichée)-->
            <div class="filter-item col-4 mb-5" v-if="showFilterSupplierId() && LMSGsupplierconfig">
              <label class="filter-item-title" for="filterSupplierId">
                {{ $t('filter.supplier_id') }}
              </label>
              <span class="filter-item-content">
                <input v-model="filterSupplierId"
                  id="filterSupplierId"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSupplierId}"
                  :placeholder="$t('filter.supplier_id')">
                </input>
              </span>
            </div>

            <!-- Filtre SIREN du fournisseur -->
            <div class="filter-item col-4 mb-5" v-if="showFilterSupplierSIREN()">
              <label class="filter-item-title" for="filterSiren">
                {{ $t('common.srn') }}
              </label>
              <span class="filter-item-content">
                <input v-model="filterSiren"
                  id="filterSiren"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSiren}"
                  :placeholder="$t('common.srn_placeholder_supplier')">
                </input>
              </span>
            </div>

            <!-- Filtre raison sociale du fournisseur -->
            <div class="filter-item col-4 mb-5" v-if="showFilterSupplierName()">
              <label class="filter-item-title" for="filterSupplierName">{{ $t('common.social_reason') }}</label>
              <span class="filter-item-content">
                <input v-model="filterSupplierName"
                  id="filterSupplierName"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSupplierName}"
                  :placeholder="$t('filter.social_reason_placeholder')">
                </input>
              </span>
            </div>

            <!-- Type du document -->
            <div class="filter-item col-4 mb-5" v-if="showFilterDoctype()">
              <label class="filter-item-title" for="filterDocumentType">{{ 'Type du document' }}</label>
              <span class="filter-item-content d-flex">
                <select ref="selectDoctype"
                  id="filterDocumentType"
                  v-model="filterDocumentType"
                  class="cursor fs-14px h-auto z-2">
                  <option value=""></option>
                  <option value="IDCARD">Carte d'identité</option>
                  <option value="RIB">RIB</option>
                  <option value="Kbis">Kbis</option>
                </select>
                <i class="fa-light fa-chevron-down cursor ml--20px z-1" size="17px" id="status-chevron">
                </i>
              </span>
            </div>
            <!-- Filtre raison -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterReason()">
              <label class="filter-item-title text-ellipsis" for="filterReason" :title="$t('filter.reason')">{{ $t('filter.reason') }}</label>
              <span class="filter-item-content">
                <input v-model="reason" @input="delayApplyFilter(modeFilter)"
                  id="filterReason"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': reason}"
                  :placeholder="$t('filter.reason_placeholder')">
                </input>
              </span>
            </div>

            <!-- Filtre statut -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterStatus() && serviceId === '1'">
              <span class="filter-item-title text-ellipsis" :title="serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label')">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
              </span>
              <a :id="'status-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                href="#">
                <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
                <span :class="'fixed-span-size ' + (statusDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ statusDisplay.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
              </a>
              <b-popover :target="'status-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_status_none')"
                triggers="focus" placement="bottom">
                <div>
                  <span class="DealPrudencecolorBlack">{{ $t('filter.standard_title') }}</span>
                  <span v-for="(status, index) in statusList" :key="$t('common.status.rtp.' + status.id) + '-' + index">
                    <b-form-checkbox v-model="status.state"
                      v-if="showStatus(status) && arrayStatusListStandard.includes(status.id)" @input="delayApplyFilter(modeFilter)"
                      :value="1"
                      :unchecked-value="0">
                      <span class="font-weight-normal fs-13px">{{ $t('common.status.rtp.' + status.id) }}</span>
                    </b-form-checkbox>
                  </span>
                </div>
                <hr class="my-1 margin-hr-status">
                <div>
                  <span class="DealPrudencecolorBlack">{{ $t('filter.rejection_title') }}</span>
                  <span v-for="(status, index) in statusList" :key="$t('common.status.rtp.' + status.id) + '-' + index">
                    <b-form-checkbox v-model="status.state"
                      v-if="showStatus(status) && arrayStatusListRejection.includes(status.id)" @input="delayApplyFilter(modeFilter)"
                      :value="1"
                      :unchecked-value="0">
                      <span class="font-weight-normal fs-13px">{{ $t('common.status.rtp.' + status.id) }}</span>
                    </b-form-checkbox>
                  </span>
                </div>
                <hr class="my-1 margin-hr-status">
                <div>
                  <span class="DealPrudencecolorBlack">{{ $t('filter.recall_title') }}</span>
                  <span v-for="(status, index) in statusList" :key="$t('common.status.rtp.' + status.id) + '-' + index">
                    <b-form-checkbox v-model="status.state"
                      v-if="showStatus(status) && arrayStatusListRecall.includes(status.id)" @input="delayApplyFilter(modeFilter)"
                      :value="1"
                      :unchecked-value="0">
                      <span class="font-weight-normal fs-13px">{{ $t('common.status.rtp.' + status.id) }}</span>
                    </b-form-checkbox>
                  </span>
                </div>
                <hr class="my-1 margin-hr-status">
                <div>
                  <span class="DealPrudencecolorBlack">{{ $t('filter.payment_title') }}</span>
                  <span v-for="(status, index) in statusList" :key="$t('common.status.rtp.' + status.id) + '-' + index">
                    <b-form-checkbox v-model="status.state"
                      v-if="showStatus(status) && arrayStatusListPayment.includes(status.id)" @input="delayApplyFilter(modeFilter)"
                      :value="1"
                      :unchecked-value="0">
                      <span class="font-weight-normal fs-13px">{{ $t('common.status.rtp.' + status.id) }}</span>
                    </b-form-checkbox>
                  </span>
                </div>
              </b-popover>
            </div>

            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterStatus() && serviceId !== '1'">
              <span class="filter-item-title text-ellipsis" :title="serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label')">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
              </span>
              <a :id="'status-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                href="#">
                <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
                <span :class="{'filter-item-input-complete':statusDisplay.nb > 0}">{{ statusDisplay.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
              </a>
              <b-popover :target="'status-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_status_none')"
                triggers="focus" placement="bottomright">
                <span v-for="(status, index) in statusList" :key="status.name + '-' + index">
                  <b-form-checkbox v-model="status.state"
                    v-if="showStatus(status)"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ status.label }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </div>
            <!-- <div class="filter-item mb-5" v-if="showFilterStatusKYC()">
              <form-write-group-label-input isMandatory
              :inputType="'listeSelect'"
              :inputLabel=" serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label')">
                <select class="form-control" id="sel2" readonly v-model="status">
                  <option value="">{{ $t('acceptance.select_stat') }}</option>
                  <option v-for="status in statusKYC" :key="status.code" :value="status.code">
                    {{ status.label }}
                  </option>
                </select>
              </form-write-group-label-input>
            </div> -->

            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterStatusKYC()">
              <label class="filter-item-title ml-2px text-ellipsis" for="filterStatusKYC" :title="serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label')">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
                <span class="color-red">* </span>
              </label>
              <span class="filter-item-content d-flex">
                <select id="filterStatusKYC"
                v-model="status"
                class="cursor fs-13px h-auto z-2 color-grey-span-filterKYC">
                  <option value="">{{ $t('acceptance.select_stat') }}</option>
                  <option v-for="status in statusKYC" :key="status.code" :value="status.code">
                    {{ status.label }}
                  </option>
                </select>
                <i class="fa-light fa-chevron-down cursor ml--20px z-1" size="17px" id="status-chevron">
                </i>
              </span>
            </div>

            <!-- <div class="filter-item mb-5" v-if="showFilterStatusVerif()">
              <form-write-group-label-input isMandatory
              :inputType="'listeSelect'"
              :inputLabel=" serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label')">
                <select class="form-control" id="sel2" readonly v-model="status">
                  <option value="">{{ $t('acceptance.select_stat') }}</option>
                  <option v-for="status in statusVerif" :key="status.code" :value="status.code">
                    {{ status.label }}
                  </option>
                </select>
              </form-write-group-label-input>
            </div>-->

            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterStatusVerif()">
              <label class="filter-item-title ml-2px text-ellipsis" for="filterStatusVerif" :title="serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label')">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
                <span class="color-red">* </span>
              </label>
              <span class="filter-item-content d-flex">
                <select id="filterStatusVerif"
                v-model="status"
                class="cursor fs-13px h-auto z-2 color-grey-span-filterKYC">
                  <option value="">{{ $t('acceptance.select_stat') }}</option>
                  <option v-for="status in statusVerif" :key="status.code" :value="status.code">
                    {{ status.label }}
                  </option>
                </select>
                <i class="fa-light fa-chevron-down cursor ml--20px z-1" size="17px" id="status-chevron">
                </i>
              </span>
            </div>

            <!-- Filtre contact (nom interlocuteur) -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterContactName()">
              <label class="filter-item-title text-ellipsis" for="filterContactName" :title="$t('filter.cntct_name')">{{ $t('filter.cntct_name') }}</label>
              <span class="filter-item-content">
                <input id="filterContactName" v-model="cdtrOrDbtrNm" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': cdtrOrDbtrNm}"
                  :placeholder="$t('filter.cntct_name_placeholder')">
                </input>
              </span>
            </div>

            <!-- Filtre debtor id (debtor IBAN) -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterDebtorId()">
              <label class="filter-item-title text-ellipsis" for="filterDebtorId" :title="$t('common.debtor_ibn')">{{ $t('common.debtor_ibn') }}</label>
              <span class="filter-item-content">
                <input id="filterDebtorId" v-model="debtorId" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': debtorId}"
                  :placeholder="$t('common.debtor_ibn')">
                </input>
              </span>
            </div>

            <!-- Filtre debtor provider -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterDebtorIdProvider()">
              <label class="filter-item-title text-ellipsis" for="filterDebtorIdProvider" :title="$t('requestToPay.provider_dbtor')">{{ $t('requestToPay.provider_dbtor') }}</label>
              <span class="filter-item-content">
                <input id="filterDebtorIdProvider" v-model="debtorIdProvider" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': debtorIdProvider}"
                  :placeholder="$t('requestToPay.provider_dbtor')">
                </input>
              </span>
            </div>

            <!-- Filtre creditor provider -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterCreditorIdProvider()">
              <label class="filter-item-title text-ellipsis" for="filterCreditorIdProvider" :title="$t('requestToPay.provider_crdtr')">{{ $t('requestToPay.provider_crdtr') }}</label>
              <span class="filter-item-content">
                <input id="filterCreditorIdProvider" v-model="creditorIdProvider" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': creditorIdProvider}"
                  :placeholder="$t('requestToPay.provider_crdtr')">
                </input>
              </span>
            </div>

            <!-- Filtre message ID -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterMsgId()">
              <label class="filter-item-title text-ellipsis" for="filterMsgId" :title="$t('filter.msgId')">{{ $t('filter.msgId') }}</label>
              <span class="filter-item-content">
                <input id="filterMsgId" v-model="msgId" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': msgId}"
                  :placeholder="$t('filter.msgId')">
                </input>
              </span>
            </div>

            <!-- Filtre type d'action -->
            <div class="filter-item mb-5" v-if="showFilterTypeAction()">
              <label class="filter-item-title" for="filterTypeAction">{{ $t('filter.action_type') }}</label>
              <span class="filter-item-content d-flex">
                <select id="filterTypeAction" ref="selectTypeAction"
                  v-model="typeAction"
                  class="cursor fs-14px h-auto z-2">
                  <option value="">{{ $t('filter.action_type_choose') }}</option>
                  <option value="CREATE">{{ $t('history.CREATE') }}</option>
                  <option value="DELETE">{{ $t('history.DELETE') }}</option>
                  <option value="MODIFY">{{ $t('history.MODIFY') }}</option>
                  <option value="SEND">{{ $t('history.SEND') }}</option>
                  <option value="CANCEL">{{ $t('history.CANCEL') }}</option>
                  <option value="ACCEPT">{{ $t('history.ACCEPT') }}</option>
                  <option value="REFUSE">{{ $t('history.REFUSE') }}</option>
                  <option value="MODIFY_AND_ACCEPT">{{ $t('history.MODIFY_AND_ACCEPT') }}</option>
                  <option value="ACCEPT_AND_PAY">{{ $t('history.ACCEPT_AND_PAY') }}</option>
                  <option value="PAY">{{ $t('history.PAY') }}</option>
                  <option value="SAVE">{{ $t('history.SAVE') }}</option>
                  <option value="UPLOAD">{{ $t('history.UPLOAD') }}</option>
                  <option value="UPLOAD_API">{{ $t('history.UPLOAD_API') }}</option>
                </select>
                <i class="fa-light fa-chevron_down cursor ml--20px z-1" size="17px" id="status-chevron">
                </i>
              </span>
            </div>

            <!-- Filtre endToEndId -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterEndToEndId()">
              <label class="filter-item-title text-ellipsis" for="filterEndToEndId" :title="$t('common.invc_ref')">{{ $t('common.invc_ref') }}</label>
              <span class="filter-item-content">
                <input id="filterEndToEndId" v-model="endToEndId" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': endToEndId}"
                  :placeholder="'End To End Id'">
                </input>
              </span>
            </div>

            <!-- Filtre user -->
            <div class="filter-item mb-5" v-if="showFilterUser()">
              <label class="filter-item-title" for="filterUser">{{ 'Utilisateur' }}</label>
              <span class="filter-item-content">
                <input id="filterUser" v-model="user" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': user}"
                  :placeholder="'Saisir l\'identifiant'">
                </input>
              </span>
            </div>

            <!-- Filtre date de début -->
            <div class="filter-item col-4 mb-5" >
              <span class="filter-item-title text-ellipsis" :title="$t('common.date_start_label')">
                {{ $t('common.date_start_label') }}
              </span>
              <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="dateBegin"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
            </div>

            <!-- Filtre date de fin -->
            <div class="filter-item col-4 mb-5" >
              <span class="filter-item-title text-ellipsis" :title="$t('common.date_end_label')">
                {{ $t('common.date_end_label') }}
              </span>
              <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="dateEnd"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
            </div>

            <!-- Filtre Clearing -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterClearing()">
              <span class="filter-item-title text-ellipsis" :title="$t('filter.clearing')">
                {{ $t('filter.clearing') }}
              </span>
              <a :id="'clearingType-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                href="#">
                <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
                <span :class="'fixed-span-size ' + (clearingDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ clearingDisplay.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="clearingType-chevron"></i>
              </a>
              <b-popover :target="'clearingType-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_clearing_type_none')"
                triggers="focus" placement="bottom">
                <span v-for="(clearing, index) in clearingList" :key="$t('filter.orphan.clearing.' + clearing.id) + '-' + index">
                  <b-form-checkbox v-model="clearing.state" @input="delayApplyFilter(modeFilter)"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ $t('filter.orphan.clearing.' + clearing.id) }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </div>

            <!-- Filtre Message Type -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterMsgType()">
              <span class="filter-item-title text-ellipsis" :title="$t('common.routing.message')">
                {{ $t('common.routing.message') }}
              </span>
              <a :id="'msgType-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                href="#">
                <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
                <span :class="'fixed-span-size ' + (messageTypeDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ messageTypeDisplay.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="msgType-chevron"></i>
              </a>
              <b-popover :target="'msgType-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_msg_type_none')"
                triggers="focus" placement="bottom">
                <span v-for="(type, index) in msgTypeList" :key="$t('filter.orphan.message_type.' + type.id) + '-' + index">
                  <b-form-checkbox v-model="type.state" @input="delayApplyFilter(modeFilter)"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ $t('filter.orphan.message_type.' + type.id) }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </div>

            <!-- Filtre Init Party -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterInitParty()">
              <span class="filter-item-title text-ellipsis" :title="$t('orphan.init_party')">{{ $t('orphan.init_party') }}</span>
              <span class="filter-item-content">
                <input v-model="initParty" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': msgId}"
                  :placeholder="$t('orphan.init_party')">
                </input>
              </span>
            </div>

            <!-- Filtre Message ID (OrphanFlux) -->
            <div class="filter-item col-4 mb-5 text-truncate" v-if="showFilterMsgIdOrphan()">
              <span class="filter-item-title text-ellipsis" :title="$t('orphan.msg_identifier')">{{ $t('orphan.msg_identifier') }}</span>
              <span class="filter-item-content">
                <input v-model="msgId" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': msgId}"
                  :placeholder="$t('orphan.msg_identifier')">
                </input>
              </span>
            </div>
          </b-col>

          <!-- Bouton Effacer et Appliquer -->
          <b-col cols="4" class="d-flex flex-row-reverse" :class="modeFilter === 3 ? 'mt-5' : 'mt-4'">
            <b-button size="sm"
              @click="applyFilter(modeFilter)">
              {{ $t('filter.fltr') }}
            </b-button>
            <b-button class="mr-2 d-inline d-xl-none" size="sm"
              @click="clearFilterFields"
              :disabled="!hasInputFilter">
              {{ $t('creation_forms.clear_label') }}
            </b-button>
            <b-button class="mr-2 d-none d-xl-inline" size="sm"
              @click="clearFilterFields"
              :disabled="!hasInputFilter">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
          </b-col>
        </b-row>
      </f7-list-item>
    </f7-list>
  </div>

</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
// import statusListJson from '@/components/common/Filter/statusList.json'

import { formatDateTime } from '@/helpers/format'
import { statusLabel, statusIcon } from '@/helpers/labels.js'
import services from '@/helpers/services.js'
import Status from '@/helpers/status.js'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import moment from 'moment-timezone'

export default {
  name: 'MessagesFilter',
  components: {
    'datetime-picker-custom': dateTimePicker,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    aloneTab: {
      type: Boolean,
      default: true
    },
    buttonCreateSupplier: {
      type: Boolean,
      default: false
    },
    buttonCreateVerify: {
      type: Boolean,
      default: false
    },
    filterType: {
      type: String,
      default: 'list'
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    isBackOffice: {
      type: Boolean,
      default: false
    },
    isCompany: {
      type: Boolean,
      default: false
    },
    isRTPListBack: {
      type: Boolean,
      default: false
    },
    isPayments: {
      type: Boolean,
      default: true
    },
    isVerifications: {
      type: Boolean,
      default: false
    },
    listMainTitle: {
      type: String,
      default: ''
    },
    loadFilters: {
      default: '0',
      type: String
    },
    mode: {
      type: Number,
      default: 1
    },
    propedServiceId: {
      type: String,
      default: 'none'
    },
    randomId: {
      type: String,
      default: ''
    },
    received: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      arrayStatusListPayment: ['19', '20', '21', '22', '23'],
      arrayStatusListStandard: ['1', '5', '9', '10', '11'],
      arrayStatusListRecall: ['13', '14', '15'],
      arrayStatusListRejection: ['6', '12'],
      clearing: '',
      clearingList: {
        EBA: {
          label: this.$t('requestToPay.norms.SRTP'),
          id: '1',
          icon: '',
          state: 0
        },
        GIRO: {
          label: this.$t('requestToPay.norms.HRTP'),
          id: '2',
          icon: '',
          state: 0
        }
      },
      dir: 0,
      displayFilter: true,
      hasDefaultFilter: false,
      dateBegin: '',
      dateEnd: '',
      debtorId: '',
      debtorIdProvider: '',
      creditorIdProvider: '',
      cdtrOrDbtrNm: '',
      endToEndId: '',
      initParty: '',
      msgId: '',
      msgType: '',
      msgTypeList: {
        Report: {
          label: this.$t('filter.report'),
          id: '1',
          icon: '',
          state: 0
        },
        CancellationReport: {
          label: this.$t('filter.cnclltn_report'),
          id: '2',
          icon: '',
          state: 0
        },
        CancellationRequest: {
          label: this.$t('filter.cnclltn_request'),
          id: '3',
          icon: '',
          state: 0
        },
        PaymentReport: {
          label: this.$t('filter.cnclltn_report'),
          id: '5',
          icon: '',
          state: 0
        },
      },
      reason: '',
      role: 2,
      typeAction: '',
      user: '',
      status: '',
      filterDocumentType: '',
      filterSiren: '',
      filterSupplierName: '',
      filterSupplierId: '',
      filterTypeGet: 'list',
      LMSGsupplierconfig: [],
      modeFilter: this.mode,
      services: services,
      statusKYC: [
        {
          code: 20,
          label: this.$t('common.status.provider_to_refresh')
        }
      ],
      statusVerif: [
        {
          code: 1,
          label: this.$t('acceptance.ok')
        },
        {
          code: 3,
          label: this.$t('acceptance.warn')
        },
        {
          code: 4,
          label: this.$t('acceptance.ko')
        }
      ],
      statusList: {
        statusIssued: {
          label: statusLabel(this.$i18n, Status.RTP_ISSUED),
          id: '1',
          icon: '',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusWaiting: {
          label: statusLabel(this.$i18n, Status.RTP_WAITING),
          id: '1',
          icon: statusIcon(Status.WAITING),
          state: 0,
          filterName: 'list',
          services: ['2', '6']
        },
        statusExpired: {
          label: statusLabel(this.$i18n, Status.RTP_EXPIRED),
          id: '12',
          icon: statusIcon(Status.EXPIRED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusExpiring: {
          id: '120',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusCanceled: {
          id: '14',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusBeingCanceled: {
          id: '13',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusCancellationRejected: {
          id: '15',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        // statusNegotiationRequest: {
        //   label: statusLabel(this.$i18n, Status.WAITING, '10'),
        //   icon: statusIcon(Status.WAITING, '10'),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        // statusNegotiationResponse: {
        //   label: statusLabel(this.$i18n, Status.WAITING, '11'),
        //   icon: statusIcon(Status.WAITING, '11'),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        statusRequestReceived: {
          label: statusLabel(this.$i18n, Status.RTP_RECEIVED),
          id: '5',
          icon: statusIcon(Status.RECEIVED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestAccepted: {
          label: statusLabel(this.$i18n, Status.RTP_ACCEPTED),
          id: '10',
          icon: statusIcon(Status.ACCEPTED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestRevoked: {
          label: statusLabel(this.$i18n, Status.RTP_REVOKED),
          id: '11',
          icon: statusIcon(Status.REVOKED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestModified: {
          label: statusLabel(this.$i18n, Status.RTP_MODIFIED),
          id: '9',
          icon: statusIcon(Status.MODIFIED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        // statusAcceptedAndPayed: {
        //   label: statusLabel(this.$i18n, Status.ACCEPTED_AND_PAYED),
        //   icon: statusIcon(Status.ACCEPTED_AND_PAYED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        // statusAcceptedAndPayedInstant: {
        //   label: statusLabel(this.$i18n, Status.ACCEPTED_AND_PAYED_INST),
        //   icon: statusIcon(Status.ACCEPTED_AND_PAYED_INST),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        // statusModifiedAndPayed: {
        //   label: statusLabel(this.$i18n, Status.MODIFIED_AND_PAYED),
        //   icon: statusIcon(Status.MODIFIED_AND_PAYED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        // statusModifiedAndPayedInstant: {
        //   label: statusLabel(this.$i18n, Status.MODIFIED_AND_PAYED_INST),
        //   icon: statusIcon(Status.MODIFIED_AND_PAYED_INST),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        // statusCreditTransferGenerated: {
        //   label: statusLabel(this.$i18n, Status.ORDER_GENERATED),
        //   icon: statusIcon(Status.ORDER_GENERATED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1', '2', '6']
        // },
        // statusCreditTransferGeneratedInstant: {
        //   label: statusLabel(this.$i18n, Status.INST_ORDER_GENERATED),
        //   icon: statusIcon(Status.INST_ORDER_GENERATED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1', '6']
        // },
        // statusBankStatementReceived: {
        //   label: statusLabel(this.$i18n, Status.MADE),
        //   icon: statusIcon(Status.MADE),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1', '2', '6']
        // },
        // statusBankStatementReceivedInstant: {
        //   label: statusLabel(this.$i18n, Status.INST_MADE),
        //   icon: statusIcon(Status.INST_MADE),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1', '6']
        // },
         statusInstallmentPaid: {
           label: statusLabel(this.$i18n, Status.RTP_INSTALLMENT_PAID),
           id:'30',
           icon: statusIcon(Status.INSTALLMENT_PAID),
           state: 0,
           filterName: 'list',
           services: ['1']
         },
        // statusCanceled: {
        //   label: statusLabel(this.$i18n, Status.CANCELED),
        //   icon: statusIcon(Status.CANCELED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1', '2', '6']
        // },
        // statusCanceledConfirm: {
        //   label: statusLabel(this.$i18n, Status.CANCELED_CONFIRM),
        //   icon: statusIcon(Status.CANCELED_CONFIRM),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1', '2', '6']
        // },
        // statusCanceledReject: {
        //   label: statusLabel(this.$i18n, Status.CANCELED_ABORT),
        //   icon: statusIcon(Status.CANCELED_ABORT),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1', '2', '6']
        // },
        statusRejected: {
          label: statusLabel(this.$i18n, Status.REJECTED),
          id: '6',
          icon: statusIcon(Status.REJECTED),
          state: 0,
          filterName: 'list',
          services: ['1', '2']
        },
        statusPaymentWaitingInitiation: {
          id: '19',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentInitiated: {
          id: '20',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentValidated: {
          id: '21',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentRejected: {
          id: '22',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentPartiallySettled: {
          id: '23',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        // statusInformation: {
        //   label: statusLabel(this.$i18n, Status.INFORMATION),
        //   icon: statusIcon(Status.INFORMATION),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['6']
        // },
        // statusNotClosedFolder: {
        //   label: statusLabel(this.$i18n, Status.NOT_CLOSED_FOLDER),
        //   icon: statusIcon(Status.NOT_CLOSED_FOLDER),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['7']
        // },
        // statusClosedFolder: {
        //   label: statusLabel(this.$i18n, Status.CLOSED_FOLDER),
        //   icon: statusIcon(Status.CLOSED_FOLDER),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['7']
        // },
        // statusFolderContainingExpired: {
        //   label: statusLabel(this.$i18n, Status.FOLDER_CONTAINING_EXPIRED),
        //   icon: statusIcon(Status.FOLDER_CONTAINING_EXPIRED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['7']
        // },
        // statusFolderContainingRefused: {
        //   label: statusLabel(this.$i18n, Status.FOLDER_CONTAINING_REFUSED),
        //   icon: statusIcon(Status.FOLDER_CONTAINING_REFUSED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['7']
        // },
        // statusDocInitialized: {
        //   label: statusLabel(this.$i18n, Status.DOC_INITIALIZED),
        //   icon: statusIcon(Status.DOC_INITIALIZED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['8']
        // },
        // statusKYCwaiting: {
        //   label: statusLabel(this.$i18n, Status.PROVIDER_OPEN),
        //   icon: statusIcon(Status.PROVIDER_OPEN),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['8']
        // },
        // statusKYCvalidated: {
        //   label: statusLabel(this.$i18n, Status.PROVIDER_VALIDATED),
        //   icon: statusIcon(Status.PROVIDER_VALIDATED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['8']
        // },
        // statusKYCrefused: {
        //   label: statusLabel(this.$i18n, Status.PROVIDER_NOT_VALIDATED),
        //   icon: statusIcon(Status.PROVIDER_NOT_VALIDATED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['8']
        // },
        // statusKYCtorefresh: {
        //   label: statusLabel(this.$i18n, Status.PROVIDER_TO_REFRESH),
        //   icon: statusIcon(Status.PROVIDER_TO_REFRESH),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['8']
        // },
        // statusKYCclosed: {
        //   label: statusLabel(this.$i18n, Status.PROVIDER_CLOSED),
        //   icon: statusIcon(Status.PROVIDER_CLOSED),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['8']
        // },
        // statusRequestSent: {
        //   label: statusLabel(this.$i18n, Status.DOC_REQUEST_SENT),
        //   icon: statusIcon(Status.DOC_REQUEST_SENT),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocRequestReceived: {
        //   label: statusLabel(this.$i18n, Status.DOC_REQUEST_RECEIVED),
        //   icon: statusIcon(Status.DOC_REQUEST_RECEIVED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocRequestRejected: {
        //   label: statusLabel(this.$i18n, Status.DOC_REQUEST_REJECTED),
        //   icon: statusIcon(Status.DOC_REQUEST_REJECTED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocRequestCanceled: {
        //   label: statusLabel(this.$i18n, Status.DOC_REQUEST_CANCELED),
        //   icon: statusIcon(Status.DOC_REQUEST_CANCELED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocRequestOutTime: {
        //   label: statusLabel(this.$i18n, Status.DOC_REQUEST_OUT_TIME),
        //   icon: statusIcon(Status.DOC_REQUEST_OUT_TIME),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocRequestAccepted: {
        //   label: statusLabel(this.$i18n, Status.DOC_REQUEST_ACCEPTED),
        //   icon: statusIcon(Status.DOC_REQUEST_ACCEPTED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocRequestRefused: {
        //   label: statusLabel(this.$i18n, Status.DOC_REQUEST_REFUSED),
        //   icon: statusIcon(Status.DOC_REQUEST_REFUSED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocSent: {
        //   label: statusLabel(this.$i18n, Status.DOC_SENT),
        //   icon: statusIcon(Status.DOC_SENT),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocReceived: {
        //   label: statusLabel(this.$i18n, Status.DOC_RECEIVED),
        //   icon: statusIcon(Status.DOC_RECEIVED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocRejected: {
        //   label: statusLabel(this.$i18n, Status.DOC_REJECTED),
        //   icon: statusIcon(Status.DOC_REJECTED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocValidated: {
        //   label: statusLabel(this.$i18n, Status.DOC_VALIDATED),
        //   icon: statusIcon(Status.DOC_VALIDATED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocRefused: {
        //   label: statusLabel(this.$i18n, Status.DOC_REFUSED),
        //   icon: statusIcon(Status.DOC_REFUSED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDocExpired: {
        //   label: statusLabel(this.$i18n, Status.DOC_EXPIRED),
        //   icon: statusIcon(Status.DOC_EXPIRED),
        //   state: 0,
        //   filterName: 'details',
        //   services: ['7', '8']
        // },
        // statusDraftNeedCompleted: {
        //   label: statusLabel(this.$i18n, Status.DRAFT_NEED_COMPLETED),
        //   icon: statusIcon(Status.DRAFT_NEED_COMPLETED),
        //   state: 0,
        //   filterName: 'draft',
        //   services: ['6']
        // },
        // statusDraftWaitingValidation: {
        //   label: statusLabel(this.$i18n, Status.DRAFT_WAITING_VALIDATION),
        //   icon: statusIcon(Status.DRAFT_WAITING_VALIDATION),
        //   state: 0,
        //   filterName: 'draft',
        //   services: ['6']
        // },
        // statusDraftWaitingUpperValidation: {
        //   label: statusLabel(this.$i18n, Status.DRAFT_WAITING_UPPER_VALIDATION),
        //   icon: statusIcon(Status.DRAFT_WAITING_UPPER_VALIDATION),
        //   state: 0,
        //   filterName: 'draft',
        //   services: ['6']
        // },
        // statusDraftReadyToSend: {
        //   label: statusLabel(this.$i18n, Status.DRAFT_READY_TO_SEND),
        //   icon: statusIcon(Status.DRAFT_READY_TO_SEND),
        //   state: 0,
        //   filterName: 'draft',
        //   services: ['6']
        // }
      },
      randomString: '',
      serviceId: '',
      timer: '',
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    // this.statusList = statusListJson.statusList
    if (this.propedServiceId === 'none') {
      this.serviceId = this.$engine.firstOn().user.currentService.id
    } else {
      this.serviceId = this.propedServiceId
    }
    this.filterTypeGet = this.filterType

    if (this.loadFilters === '1') {
      this.loadSavedFiltersInFields()
    }

    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.firstOn().services.getServiceIdByName(val)
    })
    this.$bus.emit('right-panel-set-feature', 'filter-messages')

    // Command "apply filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-apply-filter-' + this.randomId, (filter = {}) => {
      if (Object.keys(filter).length) {
        this.applyFilter(1, filter)
      } else {
        this.applyFilter()
      }
    })
    // Command "clear filter fields" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-clear-filter-fields', () => {
      this.clearFilterFields()
    })
    // Command "save filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-save-filter', () => {
      this.saveDefaultFilter()
    })
    // Command "delete filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-delete-filter', () => {
      this.deleteFilter()
    })

    // Intercepts filter changes from the right-panel-filter-view (mobile)
    this.$bus.on('filter-update-fields', (filter) => {
      for (const property in filter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = filter[property]
        } else {
          // Set filter other values
          this[property] = filter[property]
        }
      }
    })
  },
  mounted () {
    this.dir = this.$settings.msgDirection
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    let actualService = this.getActualService()
    var defaultFilter = {}
    switch (this.filterTypeGet) {
      case 'details':
        defaultFilter = actualService.filterDetails.getDefaultFilter()
        if (this.modeFilter === 2) {
          defaultFilter.statusDocRejected = 1
          defaultFilter.statusDocValidated = 1
        }
        break
      case 'draft':
        defaultFilter = actualService.filterDraft.getDefaultFilter()
        break
      case 'group':
        defaultFilter = actualService.filterGroup.getDefaultFilter()
        break
      case 'list':
        defaultFilter = actualService.filter.getDefaultFilter()
        break
      default:
        break
    }

    // Set default filter values
    this.setDefaultFilter(defaultFilter)

    // Warns right-panel-filter-view (mobile) that default values have been applied
    this.communicateChange()
  },
  beforeDestroy () {
    // this.$bus.emit('right-panel-clear-feature', 'filter-messages')
    this.$bus.off('service:change')
    this.$bus.off('filter-update-fields')
    this.$bus.off('filter-apply-filter-' + this.randomId)
    this.$bus.off('filter-save-filter')
    this.$bus.off('filter-delete-filter')
    this.$bus.off('filter-update-fields')
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    realClearingList () {
      let that = this
      const list = []
      for (const property in that.clearingList) {
        const clearing = that.clearingList[property]
        list.push({
          tag: property,
          label: clearing.label,
          icon: clearing.icon,
          state: clearing.state,
          id: clearing.id
        })
      }
      return list
    },
    clearingDisplay () {
      let realClearingList = this.realClearingList.filter(type => type.state === 1)
      if (realClearingList.length === 0) {
        return {
          label: this.$t('filter.selected_clearing_type_none'),
          nb: 0
        }
      } else if (realClearingList.length === 1) {
        return {
          label: this.serviceId === '1' ? this.$t('filter.orphan.clearing.' + realClearingList[0].id) : realClearingList[0].label,
          icon: realClearingList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_clearing_type_many', {nbClearingType: realClearingList.length}),
          nb: realClearingList.length
        }
      }
    },
    realMessageTypeList () {
      let that = this
      const list = []
      for (const property in that.msgTypeList) {
        const type = that.msgTypeList[property]
        list.push({
          tag: property,
          label: type.label,
          icon: type.icon,
          state: type.state,
          id: type.id
        })
      }
      return list
    },
    messageTypeDisplay () {
      let realMessageTypeList = this.realMessageTypeList.filter(type => type.state === 1)
      if (realMessageTypeList.length === 0) {
        return {
          label: this.$t('filter.selected_msg_type_none'),
          nb: 0
        }
      } else if (realMessageTypeList.length === 1) {
        return {
          label: this.serviceId === '1' ? this.$t('filter.orphan.message_type.' + realMessageTypeList[0].id) : realMessageTypeList[0].label,
          icon: realMessageTypeList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_msg_type_many', {nbMsgType: realMessageTypeList.length}),
          nb: realMessageTypeList.length
        }
      }
    },
    realStatusList () {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const status = that.statusList[property]
        list.push({
          tag: property,
          label: status.label,
          icon: status.icon,
          state: status.state,
          id: status.id
        })
      }
      return list
    },
    statusDisplay () {
      let realStatusList = this.realStatusList.filter(status => status.state === 1)
      if (realStatusList.length === 0) {
        return {
          label: this.$t('filter.selected_status_none'),
          nb: 0
        }
      } else if (realStatusList.length === 1) {
        return {
          label: this.serviceId === '1' ? this.$t('common.status.rtp.' + realStatusList[0].id) : realStatusList[0].label,
          icon: realStatusList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_status_many', {nbStatus: realStatusList.length}),
          nb: realStatusList.length
        }
      }
    },
    hasInputFilter () {
      if ((this.statusDisplay.nb > 0 && this.modeFilter !== 2) ||
        this.clearingDisplay.nb > 0 ||
        this.messageTypeDisplay.nb > 0 ||
        this.dateBegin ||
        this.dateEnd ||
        this.clearing === 0 ||
        this.clearing ||
        this.initParty ||
        this.status === 0 ||
        this.status ||
        this.msgType === 0 ||
        this.msgType ||
        this.cdtrOrDbtrNm ||
        this.debtorId ||
        this.endToEndId ||
        this.reason ||
        this.typeAction ||
        this.user ||
        this.filterDocumentType ||
        this.filterSiren ||
        this.filterSupplierName ||
        this.filterSupplierId ||
        this.debtorIdProvider ||
        this.creditorIdProvider ||
        this.msgId ) {
        return true
      }
      return false
    },
    listTitle () {
      let fromServiceIdToLabel = {
        0: {
          '6': this.$t('Webheader.my_drafts')
        },
        1: {
          '1': this.$t('Webheader.my_claims_list'),
          '2': this.$t('Webheader.my_modular_loans'),
          '6': this.$t('Webheader.my_transfers'),
          '7': this.$t('Webheader.my_business_folders'),
          '8': this.$t('Webheader.my_suppliers')
        },
        2: {
          '1': this.$t('Webheader.my_claims_folders'),
          '7': this.$t('Webheader.my_business_documents_to_validate')
        }
      }
      if (this.isHistory) {
        return this.$t('Webheader.history')
      } else if (this.isCompany) {
        return this.$t('Webheader.company')
      } else if (this.isVerifications) {
        return this.$t('Webheader.my_verifications')
      }
      if (this.listMainTitle === '') {
        return fromServiceIdToLabel[this.modeFilter][this.$engine.firstOn().user.currentService.id]
      }
      return this.listMainTitle
    },
    filterFields () {
      let that = this
      let filter = {}

      // Date, Reason and Name values
      filter.dateBegin = this.dateBegin
      filter.dateEnd = this.dateEnd
      filter.standard = this.clearing
      filter.initParty = this.initParty
      filter.status = this.status
      filter.SocialReason = this.filterSupplierName
      filter.cdtrOrDbtrNm = this.cdtrOrDbtrNm
      filter.debtorId = this.debtorId
      filter.endToEndId = this.endToEndId
      filter.reason = this.reason
      filter.typeAction = this.typeAction
      filter.user = this.user
      filter.filterDocumentType = this.filterDocumentType
      filter.filterSiren = this.filterSiren
      filter.filterSupplierName = this.filterSupplierName
      filter.filterSupplierId = this.filterSupplierId
      filter.hasDefaultFilter = this.hasDefaultFilter
      filter.debtorIdProvider = this.debtorIdProvider
      filter.msgId = this.msgId
      filter.creditorIdProvider = this.creditorIdProvider

      // Status values
      for (let property in this.statusList) {
        let status = that.statusList[property]
        filter[property] = status.state
      }

      // Clearing values
      for (let property in this.clearingList) {
        let clearing = that.clearingList[property]
        filter[property] = clearing.state
      }

      // Message type values
      for (let property in this.msgTypeList) {
        let type = that.msgTypeList[property]
        filter[property] = type.state
      }

      return filter
    }
  },
  methods: {
    applyFilter (mode = 1, filterConditions = {}) {
      let that = this
      clearTimeout(this.timer) //Annule le delayApplyFilter
      if (this.modeFilter !== mode) {
        //this.clearFilterFields()
        this.modeFilter = mode
        switch (this.modeFilter) {
          case 0:
            this.filterTypeGet = 'draft'
            break
          case 1:
            this.filterTypeGet = 'list'
            break
          case 2:
            this.filterTypeGet = 'group'
            break
          default:
            this.filterTypeGet = 'list'
            break
        }
        let actualService = this.getActualService()
        var defaultFilter = {}
        switch (this.filterTypeGet) {
          case 'details':
            defaultFilter = actualService.filterDetails.getDefaultFilter()
            break
          case 'draft':
            defaultFilter = actualService.filterDraft.getDefaultFilter()
            break
          case 'group':
            defaultFilter = actualService.filterGroup.getDefaultFilter()
            break
          case 'list':
            defaultFilter = actualService.filter.getDefaultFilter()
            break
          default:
            defaultFilter = actualService.filter.getDefaultFilter()
            break
        }
        // Set default filter values
        this.setDefaultFilter(defaultFilter)
      }

      let actualService = this.getActualService()
      let actualFilter
      switch (this.filterTypeGet) {
        case 'details':
          actualFilter = actualService.filterDetails
          break
        case 'draft':
          actualFilter = actualService.filterDraft
          break
        case 'group':
          actualFilter = actualService.filterGroup
          break
        case 'list':
          actualFilter = actualService.filter
          break
        default:
          actualFilter = actualService.filter
          break
      }
      actualFilter.cleanFilterCondition()

      let statusArray = []
      for (let property in this.statusList) {
        let status = that.statusList[property]
        if(this.serviceId === '1') {
          if(status.state === 1) {
            statusArray.push(status.id)
          }
        }
        else {
          actualFilter[property] = status.state
        }
      }

      if(this.serviceId === '1') {
        actualFilter.status = statusArray.join(',')
      }
      else {
        actualFilter.status = this.status
      }

      let clearingArray = []
      for (let property in this.clearingList) {
        let clearing = that.clearingList[property]
        if(clearing.state === 1) {
          clearingArray.push(clearing.id)
        }
      }

      if(this.serviceId === '1') {
        actualFilter.standard = clearingArray.join(',')
      }
      else {
        actualFilter.standard = this.clearing
      }

      let typeMessageArray = []
      for (let property in this.msgTypeList) {
        let type = that.msgTypeList[property]
        if(type.state === 1) {
          typeMessageArray.push(type.id)
        }
      }

      if(this.serviceId === '1') {
        actualFilter.messageType = typeMessageArray.join(',')
      }
      else {
        actualFilter.messageType = this.msgType
      }

      if (this.mode === 4) {
        filterConditions.orphelan = '1'
      }

      actualFilter.dateBegin = formatDateTime(this.dateBegin)
      actualFilter.dateEnd = formatDateTime(this.dateEnd)
      actualFilter.initParty = this.initParty
      actualFilter.SocialReason = this.filterSupplierName
      actualFilter.creditorOrDebtorName = this.cdtrOrDbtrNm
      actualFilter.debtorId = this.debtorId
      actualFilter.endToEndId = this.endToEndId
      actualFilter.reason = this.reason
      actualFilter.typeAction = this.typeAction
      actualFilter.user = this.user
      actualFilter.documentType = this.filterDocumentType
      actualFilter.siren = this.filterSiren
      actualFilter.sellerName = this.filterSupplierName
      actualFilter.modeFilter = mode
      actualFilter.debtorIdProvider = this.debtorIdProvider
      actualFilter.creditorIdProvider = this.creditorIdProvider
      actualFilter.msgId = this.msgId
      actualFilter.direction = this.role !== 2 ? this.role : undefined

      for (let propertyCustom in filterConditions) {
        actualFilter[propertyCustom] = filterConditions[propertyCustom]
      }

      if (this.serviceId === '1') {
        Object.keys(actualFilter).forEach(filterName => {
          if (filterName.includes('status') && filterName !== 'status') {
            delete actualFilter[filterName]
          }
        })
      }

      this.$emit('applyFilter', actualFilter)
    },

    clearFilterFields () {
      let that = this
      for (let property in that.statusList) {
        that.statusList[property].state = 0
      }

      for (let property in that.clearingList) {
        that.clearingList[property].state = 0
      }

      for (let property in that.msgTypeList) {
        that.msgTypeList[property].state = 0
      }

      if (this.modeFilter === 2 && this.serviceId === services.DOCUMENTSERVICE) {
        that.statusList.statusDocRejected.state = 1
        that.statusList.statusDocValidated.state = 1
      }

      this.dateBegin = ''
      this.dateEnd = ''
      this.status = ''
      this.clearing = ''
      this.initParty = ''
      this.msgType = ''
      this.cdtrOrDbtrNm = ''
      this.debtorId = ''
      this.debtorIdProvider = ''
      this.creditorIdProvider = ''
      this.endToEndId = ''
      this.msgId = ''
      this.reason = ''
      this.typeAction = ''
      this.user = ''
      this.filterDocumentType = ''
      this.filterSiren = ''
      this.filterSupplierName = ''
      this.filterSupplierId = ''
      this.communicateChange()
      clearTimeout(this.timer)
      this.applyFilter(this.modeFilter)
    },
    deleteFilter () {
      let actualService = this.getActualService()
      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilter({})
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilter({})
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilter({})
          break
        case 'list':
          actualService.filter.saveDefaultFilter({})
          break
        default:
          actualService.filter.saveDefaultFilter({})
          break
      }
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: 'Filtre supprimé',
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    delayApplyFilter(modeFilter) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.applyFilter(modeFilter)
      }, 1500)
    },
    loadSavedFiltersInFields () {
      let savedFilters = this.$engine.firstOn().services.payments.filter

      if (savedFilters.dateBegin) {
        const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(savedFilters.dateBegin);
        const isoWithTZ = hasTimezone ? savedFilters.dateBegin : savedFilters.dateBegin + 'Z';
        this.dateBegin = moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss')
      }
      if (savedFilters.dateEnd) {
        const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(savedFilters.dateEnd);
        const isoWithTZ = hasTimezone ? savedFilters.dateEnd : savedFilters.dateEnd + 'Z';
        this.dateEnd = moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss')
      }
      let savedStatusArray = savedFilters.status ? savedFilters.status.split(",") : []
      let tempStatusList = this.statusList
      Object.values(tempStatusList).forEach((stat, index) => {
        savedStatusArray.forEach((savedStat, savedIndex) => {
          if (stat.id === savedStat && stat.services.includes(this.$engine.firstOn().user.currentService.id.toString())) {
            stat.state = 1
          }
        })
      })
      let savedClearingArray = savedFilters.standard.split(",")
      let tempClearingList = this.clearingList
      Object.values(tempClearingList).forEach((clearing, index) => {
        savedClearingArray.forEach((savedClearing, savedIndex) => {
          if (clearing.id === savedClearing) {
            clearing.state = 1
          }
        })
      })
      let savedMsgTypeArray = savedFilters.messageType.split(",")
      let tempMsgTypeList = this.msgTypeList
      Object.values(tempMsgTypeList).forEach((type, index) => {
        savedMsgTypeArray.forEach((savedType, savedIndex) => {
          if (type.id === savedType) {
            type.state = 1
          }
        })
      })
      this.statusList = tempStatusList
      this.msgTypeList = tempMsgTypeList
      this.clearing = tempClearingList
      this.initParty = savedFilters.initParty
      this.cdtrOrDbtrNm = savedFilters.creditorOrDebtorName
      this.debtorId = savedFilters.debtorId
      this.debtorIdProvider = savedFilters.debtorIdProvider
      this.creditorIdProvider = savedFilters.creditorIdProvider
      this.endToEndId = savedFilters.endToEndId
      this.msgId = savedFilters.msgId
      this.reason = savedFilters.reason
      this.typeAction = savedFilters.typeAction
      this.user = savedFilters.user
      this.filterDocumentType = savedFilters.documentType
      this.filterSiren = savedFilters.siren
      this.filterSupplierName = savedFilters.filterSupplierName
      this.filterSupplierId = savedFilters.filterSupplierId
    },
    saveDefaultFilter () {
      let that = this

      let actualService = this.getActualService()

      let defaultFilter = {
        dateBegin: this.dateBegin,
        dateEnd: this.dateEnd,
        Status: this.status,
        cdtrOrDbtrNm: this.cdtrOrDbtrNm,
        debtorId: this.debtorId,
        debtorIdProvider: this.debtorIdProvider,
        creditorIdProvider: this.creditorIdProvider,
        endToEndId: this.endToEndId,
        initParty: this.initParty,
        msgId: this.msgId,
        reason: this.reason,
        typeAction: this.typeAction,
        user: this.user,
        filterDocumentType: this.filterDocumentType,
        filterSiren: this.filterSiren,
        filterSupplierName: this.filterSupplierName,
        filterSupplierId: this.filterSupplierId
      }

      for (const property in this.statusList) {
        let status = that.statusList[property]
        defaultFilter[property] = status.state
      }

      for (const property in this.clearingList) {
        let clearing = that.clearingList[property]
        defaultFilter[property] = clearing.state
      }

      for (const property in this.msgTypeList) {
        let type = that.msgTypeList[property]
        defaultFilter[property] = type.state
      }

      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilter(defaultFilter)
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilter(defaultFilter)
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilter(defaultFilter)
          break
        case 'list':
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
        default:
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
      }

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getActualService () {
      if (this.isHistory) {
        return this.$engine.firstOn().history
      } else if (this.isVerifications) {
        return this.$engine.firstOn().services.verifications
      }
      let serviceName = {
        '1': this.$engine.firstOn().services.payments,
        '2': this.$engine.firstOn().services.directDebit,
        '6': this.$engine.firstOn().services.directPayments,
        '7': this.$engine.firstOn().services.businessDocuments,
        '8': this.$engine.firstOn().services.suppliers
      }
      return serviceName[this.serviceId]
    },
    hasRight (right) {
      if(this.$engine.firstOn().rights.rightIs(right, true) === true) {
        return true
      } else {
        return false
      }
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else if (this.clearingList[property] !== undefined) {
          // Set filter clearing (orphan) values
          this.clearingList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else if (this.msgTypeList[property] !== undefined) {
          // Set filter message type (orphan) values
          this.msgTypeList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else {
          // Set filter other values
          if (property !== 'modeFilter') {
            this[property] = defaultFilter[property]
            if (this[property]) {
              this.hasDefaultFilter = true
            }
          }
        }
      }
    },
    showFilterDateBegin () {
      return true //!(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterDateEnd () {
      return true // !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterContactName () {
      if (((this.filterType === 'list' && this.serviceId !== '7' && this.serviceId !== '8') ||
          (this.filterType === 'details' && (this.serviceId === '7' || this.serviceId === '8') && this.mode !== 2) ||
          this.filterType === 'draft') &&
          !this.isHistory && !this.isVerifications && ![3, 4].includes(this.mode)) {
        return true
      }
      return false
    },
    showFilterDebtorId () {
      if (this.filterType === 'list' && this.mode === 1) {
        return true
      }
      return false
    },
    showFilterDoctype () {
      return this.mode === 2 &&
        this.serviceId === services.DOCUMENTSERVICE
    },
    showFilterEndToEndId () {
      return this.isHistory || this.mode === 3 && !this.isRTPListBack
    },
    showFilterReason () {
      return this.serviceId !== '7' && this.serviceId !== '8' && !this.isHistory && !this.isVerifications && ![3, 4].includes(this.mode) && !this.isBackOffice
    },
    showButtonCreateSupplier () {
      return this.buttonCreateSupplier
    },
    showButtonCreateVerify () {
      return this.buttonCreateVerify
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    },
    showFilterStatus () {
      return ![2, 3, 4].includes(this.mode) &&
        !this.isHistory && !this.isVerifications &&
        this.serviceId !== '8'
    },
    showFilterStatusVerif () {
      return this.mode !== 2 &&
        this.isVerifications
    },
    showFilterStatusKYC () {
      return this.mode !== 2 && this.serviceId === services.SUPPLIERS
        !this.isHistory && !this.isVerifications
    },
    showFilterSupplierId () {
      return this.filterType === 'list' &&
        this.serviceId === services.SUPPLIERS
    },
    showFilterSupplierName () {
      if ((this.filterType === 'list' && this.serviceId === services.SUPPLIERS) ||
        (this.filterType === 'details' && this.serviceId === services.DOCUMENTSERVICE && this.mode === 2)) {
        return true
      }
      return false
    },
    showFilterSupplierSIREN () {
      return this.filterType === 'list' &&
        this.serviceId === services.SUPPLIERS
    },
    showFilterTypeAction () {
      return this.isHistory
    },
    showFilterUser () {
      return this.isHistory
    },
    showListDraftPanel () {
      return this.serviceId === services.DIRECTPAYMENTS
    },
    showListGroupPanel () {
      return this.serviceId === services.PAYMENTS &&
        !this.isHistory
    },
    showStatus (status) {
      return status.services.includes(this.$engine.firstOn().user.currentService.id.toString()) &&
        status.filterName === this.filterTypeGet
    },
    showFilterClearing () {
      return this.mode === 4
    },
    showFilterDebtorIdProvider () {
      return this.mode === 3
    },
    showFilterCreditorIdProvider () {
      return this.mode === 3
    },
    showFilterInitParty () {
      return this.mode === 4
    },
    showFilterMsgId () {
      return this.mode === 3 || (this.mode === 1 && this.isBackOffice)
    },
    showFilterMsgIdOrphan () {
      return this.mode === 4
    },
    showFilterMsgType () {
      return this.mode === 4
    }
  },
  watch: {
    hasDefaultFilter () {
      this.communicateChange()
    },
    dateBegin () {
      this.communicateChange()
    },
    dateEnd () {
      this.communicateChange()
    },
    Status () {
      this.communicateChange()
    },
    cdtrOrDbtrNm () {
      this.communicateChange()
    },
    endToEndId () {
      this.communicateChange()
    },
    reason () {
      this.communicateChange()
    },
    typeAction () {
      this.communicateChange()
    },
    user () {
      this.communicateChange()
    },
    filterDocumentType () {
      this.communicateChange()
    },
    filterSiren () {
      this.communicateChange()
    },
    filterSupplierName () {
      this.communicateChange()
    },
    filterSupplierId () {
      this.communicateChange()
    },
    role (val) {
      this.applyFilter(this.modeFilter)
    },
    statusList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    },
    clearingList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    },
    msgTypeList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    }
  }
}
</script>
